import { PROFILE_NAVIGATION_ENUMS } from "constants/navigation/profile";
import { MOBILE_NAVIGATION_ENUMS } from "constants/navigation/mobileNavigation";
import { TABBAR_NAVIGATION_ENUM } from "constants/navigation/tabbar";
import {
  FormatNotificationSidebarMobileParams,
  FormatNotificationSidebarProfileParams,
  FormatNotificationTabBarMobileParams,
} from "types/notificationNavigation";
import {
  mapKeysSidebar,
  mapKeysSidebarMobile,
  mapKeysTabBarMobile,
} from "constants/notificationsNavigation";

export const formatNotificationLinks = <
  T extends Record<string, boolean | undefined>,
  R,
>(
  params: T,
  map: Record<string, R>,
): R[] => {
  return Object.keys(params).reduce((cur: R[], acc) => {
    if (params[acc]) {
      return [...cur, map[acc]];
    }
    return cur;
  }, []);
};

export const formatNotificationSideBarProfile = (
  data: FormatNotificationSidebarProfileParams,
) =>
  formatNotificationLinks<
    FormatNotificationSidebarProfileParams,
    PROFILE_NAVIGATION_ENUMS
  >(data, mapKeysSidebar);

export const formatNotificationSideBarMobile = (
  data: FormatNotificationSidebarMobileParams,
) =>
  formatNotificationLinks<
    FormatNotificationSidebarMobileParams,
    MOBILE_NAVIGATION_ENUMS
  >(data, mapKeysSidebarMobile);

export const formatNotificationTabBar = (
  data: FormatNotificationTabBarMobileParams,
) =>
  formatNotificationLinks<
    FormatNotificationTabBarMobileParams,
    TABBAR_NAVIGATION_ENUM
  >(data, mapKeysTabBarMobile);
